import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { LOGIN_URL } from '../api/axiosClient';
import styles from '../static/styles/EditProfile.module.css';
import MessagePopup from '../components/MessagePopup';
import { completeRedemption } from '../api/rewards';
import { isAuthenticated } from '../api/auth';

const RedeemForm = ({ reward }) => {
    const { t } = useTranslation();
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [pubgId, setPubgId] = useState("");
    const [isSubmitting, setIsSubmitting] = useState(false);

    const [popupMessage, setPopupMessage] = useState("");
    const [isPopupOpen, setIsPopupOpen] = useState(false);

    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        document.title = `${t('redeem_form')} | Jazz ESL`;
        if(!isAuthenticated()) {
            window.location.href = LOGIN_URL;
            return;
        }
        if(!location.state) {
            navigate('/rewards');
            return;
        }

        setName(location.state.reward.name)
    }, [t, location.state, navigate]);

    const handleRedemption = () => {
        if (isSubmitting) {
            return;
        }

        const isIdRequired = location.state?.reward?.id_require;
        const isPubgIdValid = !isIdRequired || (pubgId && pubgId.length >= 9 && pubgId.length <= 13 && /^\d+$/.test(pubgId));
        const isFormValid = name && email && isPubgIdValid;

        if (isFormValid) {
            setIsSubmitting(true);

            const data = {
                item: location.state.reward.item,
                uuid: location.state.reward.uuid,
                name: name,
                email: email,
                phone: location.state.reward.tel,
            };

            if (isIdRequired) {
                data.pubgId = pubgId;
            }

            completeRedemption(data)
                .then(response => {
                    if (response.status === 200) {
                        if (response.data.success) {
                            navigate('/thankyou')
                        } else {
                            const errorMessage = response.data?.data?.message || t('redeem_fail');
                            setPopupMessage(errorMessage);
                            setIsPopupOpen(true);
                            setIsSubmitting(false);
                        }
                    } else {
                        setPopupMessage(t('redeem_fail'));
                        setIsPopupOpen(true);
                        setIsSubmitting(false);
                    }
                })
                .catch(error => {
                    setPopupMessage(t('err_long'));
                    setIsPopupOpen(true);
                    setIsSubmitting(false);
                });
        } else {
            const isIdRequired = location.state?.reward?.id_require;
            if (isIdRequired && !pubgId) {
                setPopupMessage(t('fill_pubg'));
            } else if (isIdRequired && pubgId && (pubgId.length < 9 || pubgId.length > 13 || !/^\d+$/.test(pubgId))) {
                setPopupMessage(t('pubg_limit'));
            } else {
                setPopupMessage(t('fill_all_fields'));
            }
            setIsPopupOpen(true);
        }
    }

    return (
        <div className={styles.editProfile}>
            <h3 style={{textAlign: 'center', color: '#E3931B'}}>{t('congrats')}</h3>
            <p style={{textAlign:'center'}}>{t('can_redeem_msg')}
            {t('enter_details_msg')}</p>
            <div className={styles.formGroup}>
                <label>{t('name')}</label>
                <input value={name} onChange={e => setName(e.target.value)} placeholder={t('enter_name')} required />
            </div>

            <div className={styles.formGroup}>
                <label>{t('email')}</label>
                <input
                    type="email"
                    value={email}
                    onChange={e => setEmail(e.target.value)}
                    placeholder={t('enter_email')}
                    required
                />
            </div>

            {location.state?.reward?.id_require && (
                <div className={styles.formGroup}>
                    <label>{t('pubg_id')}</label>
                    <input
                        type="text"
                        value={pubgId}
                        onChange={e => setPubgId(e.target.value.replace(/[^0-9]/g, ''))}
                        placeholder={t('enter_pubg_id')}
                        minLength={9}
                        maxLength={13}
                        required
                    />
                </div>
            )}

            <div className={styles.formGroup}>
                <label>{t('mobile_number')}</label>
                <input required value={location.state.reward.tel} />
            </div>

            <button
                className={styles.saveButton}
                onClick={handleRedemption}
                disabled={isSubmitting}
            >
                {isSubmitting ? t('processing') : t('claim')}
            </button>

            <MessagePopup
                isOpen={isPopupOpen}
                message={popupMessage}
                onClose={() => {setIsPopupOpen(false);}}
            />
        </div>
    );
};

export default RedeemForm;